module.exports = __webpack_public_path__ + "img/userB30.ee77ae67.jpg";